import gql from "graphql-tag";

// GetMonthlyApprovedPermitCount
export const GET_DASHBOARD_6_MONTHLY_APPROVED_PERMIT_COUNT = gql`
    query ($startDate: String!, $endDate: String!, $sites: [String!]!) {
        GetMonthlyApprovedPermitCount(startDate: $startDate, endDate: $endDate, sites: $sites) {
            code
            success
            message
            results {
                key
                month
                generalPermitCount
                toolInstallPermitCount
                childPermitCount
                grantTotal
            }
        }
    }
`;